import { LicenseInfo } from "@mui/x-license";
import { createBrowserRouter, Navigate } from "react-router-dom";

import Login from "../screens/Login";
import PageLayout from "./PageLayout";
import Dashboard from "../screens/Dashboard";
import Jurisdictions from "../screens/Jurisdictions";
import UsersList from "../screens/UserManagement/UsersList";
import NestedPageLayout from "./NestedPageLayout";
import ActivityLogs from "../screens/Configuration/ActivityLogs";
import ActiveSessions from "../screens/UserManagement/ActiveSessions";
import PasswordChange from "../screens/Login/PasswordChange";
import UserRoles from "../screens/RolesPermissions/UserRoles";
import RolesHierarchy from "../screens/RolesPermissions/RolesHierarchy";
import SessionsList from "../screens/VehicleLogs/SessionsList";
import Interceptors from "../screens/Configuration/Interceptors";
import AboutUs from "../screens/Configuration/AboutUs";
import Reports from "../screens/Reports";

LicenseInfo.setLicenseKey(
	"8d70d9731170b6417efb13bf3e89d1f8Tz05MTc4NCxFPTE3NDkwMjEyODAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y"
);

export const router = createBrowserRouter([
	{
		path: "/",
		element: <Navigate to="/login" />
	},
	{
		path: "/login",
		element: <Login />
	},
	{
		path: "/change-password",
		element: <PasswordChange />
	},
	{
		element: <PageLayout />,
		children: [
			{
				path: "/dashboard",
				element: <Dashboard />
			},
			{
				path: "/violation-logs",
				element: <SessionsList />
			},
			{
				path: "/roles-permissions",
				element: <NestedPageLayout />,
				children: [
					{
						path: "/roles-permissions",
						element: <Navigate to="/roles-permissions/user-roles" />
					},
					{
						path: "/roles-permissions/user-roles",
						element: <UserRoles />
					},
					{
						path: "/roles-permissions/roles-hierarchy",
						element: <RolesHierarchy />
					}
				]
			},
			{
				path: "/user-management",
				element: <NestedPageLayout />,
				children: [
					{
						path: "/user-management",
						element: <Navigate to="/user-management/users" />
					},
					{
						path: "/user-management/users",
						element: <UsersList />
					},
					{
						path: "/user-management/active-sessions",
						element: <ActiveSessions />
					}
				]
			},
			{
				path: "/reports",
				element: <Reports />
			},
			{
				path: "/configuration",
				element: <NestedPageLayout />,
				children: [
					{
						path: "/configuration",
						element: <Navigate to="/configuration/interceptors" />
					},
					{
						path: "/configuration/interceptors",
						element: <Interceptors />
					},
					{
						path: "/configuration/activity-logs",
						element: <ActivityLogs />
					},
					{
						path: "/configuration/about-us",
						element: <AboutUs />
					}
				]
			},
			{
				path: "/jurisdictions",
				element: <Jurisdictions />
			}
		]
	},
	{
		path: "*",
		element: <Navigate to="/" />
	}
]);
